import classNames from "classnames";
import React, { useContext } from "react";
import { RicosNodeContext } from "./../../ricos-context/index.js";
import collapsibleListItemStyles from "../statics/styles/collapsible-list-pair.rtlignore-scss.js";
import { getAlignmentFromDirection } from "../utils.js";
const CollapsibleListItemProperty = ({
  node,
  RicosNodesRenderer,
  type
}) => {
  const { parentNode } = useContext(RicosNodeContext);
  const parentNodeDirection = parentNode?.collapsibleListData?.direction;
  const listAlignment = parentNodeDirection ? getAlignmentFromDirection(parentNodeDirection) : void 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(
        collapsibleListItemStyles.container,
        collapsibleListItemStyles.viewerContainer,
        type === "title" ? collapsibleListItemStyles.titleContainer : null,
        collapsibleListItemStyles.innerEditor
      )
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          width: "100%",
          textAlign: listAlignment
        }
      },
      /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [], shouldParagraphApplyTextStyle: true })
    )
  );
};
const CollapsibleListItemTitleProperty = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, { key: node.id, node, ...props, type: "title" });
};
const CollapsibleListItemBodyProperty = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListItemProperty, { key: node.id, node, ...props, type: "body" });
};
var collapsibleItemProperty_default = CollapsibleListItemProperty;
export {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty,
  collapsibleItemProperty_default as default
};
//# sourceMappingURL=collapsibleItemProperty.js.map
